import React, { useEffect, useState } from 'react';
import { LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthProvider';
import { useT } from '../contexts/LocaleProvider';
import { LT } from '../lib/appCatalogue';

/* Full-screen notice for someone whose employee record was deactivated
 * (left the company): the API refuses them, so rather than broken pages
 * they see why, and a way to sign out. */
export default function DeactivatedNotice() {
  const t = useT();
  const { logout } = useAuth() || {};
  const [on, setOn] = useState(!!window.__ltDeactivated);
  useEffect(() => {
    const show = () => setOn(true);
    window.addEventListener('lt:deactivated', show);
    return () => window.removeEventListener('lt:deactivated', show);
  }, []);
  if (!on) return null;
  return (
    <div role="alertdialog" aria-modal="true" className="fixed inset-0 z-[100] grid place-items-center px-6"
         style={{ background: LT.beigeLight }}>
      <div className="max-w-[440px] text-center">
        <h1 className="font-display text-[2rem] leading-tight" style={{ color: LT.greenDeep }}>{t('deactivated.title')}</h1>
        <p className="mt-3 text-[15px] leading-relaxed" style={{ color: '#3a4f44' }}>{t('deactivated.body')}</p>
        {logout && (
          <button type="button" onClick={() => logout()}
                  className="mt-6 inline-flex items-center gap-2 h-11 px-6 rounded-full text-[15px]"
                  style={{ background: LT.greenDeep, color: LT.beigeLight }}>
            <LogOut className="h-4 w-4" /> {t('common.signOut')}
          </button>
        )}
      </div>
    </div>
  );
}
